import { createSlice } from "@reduxjs/toolkit";
import { fetchDailyLogs } from "./thunk";

interface FetchDailyLogState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: FetchDailyLogState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const DailyStateSlice = createSlice({
  name: "DailyLog",
  initialState,
  reducers: {
    clearDailyLogs: (state) => {
      state.list = [];
      state.rowCount = 0;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDailyLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchDailyLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Draft RFQ List";
      });
  },
});

export const { clearDailyLogs } = DailyStateSlice.actions;
export default DailyStateSlice.reducer;
